import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import HTTPMethod from 'http-method-enum';
import { createContext, useContext, useEffect, useState } from 'react';
import { API_USER_ENTITLEMENT } from '@poplar/constants/routes';
import { useUser } from '@poplar/hooks/useUser';
import { ApiResponseStatus, safeFetch } from '@poplar/lib/api/utils';
import { AccessType } from '@poplar/types/enums';
import { activeStatuses, canceledStatuses, pausedStatuses, previewStatuses } from '@poplar/utils/entitlements';
import { useExternalConfig } from './ExternalConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export var EntitlementContext = /*#__PURE__*/createContext(undefined);
export var getAccessType = function getAccessType(isGuideDeprecated, user, entitlement) {
  if (!user || !entitlement) {
    return AccessType.PREVIEW;
  } // Entitlement is not active


  if (previewStatuses.includes(entitlement.state)) {
    return AccessType.PREVIEW;
  } // Entitlement is canceled (or paused which behaves the same as canceled when PauseV1.1 is OFF)


  if (canceledStatuses.includes(entitlement.state)) {
    return AccessType.CANCELED;
  } // Entitlement is paused


  if (pausedStatuses.includes(entitlement.state)) {
    return AccessType.PAUSED;
  } // Entitlement is active, but user does not have a rep assigned
  // When Guide is deprecated there is no `assignedRepId` so should have full access


  if (!isGuideDeprecated && activeStatuses.includes(entitlement.state) && Boolean(!user.assignedRepId)) {
    return AccessType.LIMITED;
  }

  return AccessType.FULL;
};
export var EntitlementProvider = function EntitlementProvider(_ref) {
  var _user$profile2;

  var entitlement = _ref.entitlement,
      children = _ref.children;
  var user = useUser();

  var _useExternalConfig = useExternalConfig(),
      enableGuideDeprecation = _useExternalConfig.globalFeatures.enableGuideDeprecation;

  var _useState = useState({
    entitlement: entitlement || undefined,
    accessType: getAccessType(enableGuideDeprecation, user.profile, entitlement || undefined),
    error: undefined
  }),
      entitlementState = _useState[0],
      setEntitlementState = _useState[1];

  var refreshEntitlement = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var res, newEntitlement;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return safeFetch(API_USER_ENTITLEMENT, {
                method: HTTPMethod.GET
              });

            case 2:
              res = _context.sent;

              if (!(res.status === ApiResponseStatus.ERROR)) {
                _context.next = 6;
                break;
              }

              setEntitlementState(_objectSpread(_objectSpread({}, entitlementState), {}, {
                error: res.error
              }));
              return _context.abrupt("return", null);

            case 6:
              if (res.data && !res.error) {
                newEntitlement = res.data;
                setEntitlementState({
                  entitlement: newEntitlement,
                  accessType: getAccessType(enableGuideDeprecation, user.profile, newEntitlement)
                });
              }

              return _context.abrupt("return", null);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function refreshEntitlement() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var _user$profile;

    if ((_user$profile = user.profile) !== null && _user$profile !== void 0 && _user$profile.userId) {
      void refreshEntitlement();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [(_user$profile2 = user.profile) === null || _user$profile2 === void 0 ? void 0 : _user$profile2.userId]);
  return /*#__PURE__*/_jsx(EntitlementContext.Provider, {
    value: _objectSpread(_objectSpread({}, entitlementState), {}, {
      actions: {
        refreshEntitlement: refreshEntitlement
      }
    }),
    children: children
  });
};
export var useEntitlement = function useEntitlement() {
  var context = useContext(EntitlementContext);

  if (context === undefined) {
    throw new Error('useEntitlement must be used within a EntitlementProvider');
  }

  return context;
};